import { render, staticRenderFns } from "./LocationTab.vue?vue&type=template&id=de8a7926&scoped=true&"
import script from "./LocationTab.vue?vue&type=script&lang=js&"
export * from "./LocationTab.vue?vue&type=script&lang=js&"
import style0 from "./LocationTab.vue?vue&type=style&index=0&id=de8a7926&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8a7926",
  null
  
)

export default component.exports